'use strict';

angular.module('adminSupervisorReviewRoutes', ['AdminSupervisorReviewControllers',
                                               'services.accessReview',
                                               'services.authenticatedUser'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('adminSupervisorReview', {
            url: '/Administration/SupervisorReview',
            templateUrl: require('./AdminSupervisorAccessReview.tpl.html'),
            controller: 'AdminSupervisorAccessReviewController',
            resolve: {
                systemsAndSysRoles: [
                    'adminSupervisorReviewService', function (service) {
                        return service.getSupervisorsSystemsAndSysRoles();
                    }
                ],
                accessReview: [
                    'accessReviewService', function (service) {
                        return service.getCurrentAccessReview();
                    }
                ],
                authenticatedUser: [
                    'authenticatedUserService', function (service) {
                        return service.getAuthenticatedUser();
                    }
                ],
            }
        });
}]);